/* eslint-disable i18next/no-literal-string */
import { useQuery } from '@apollo/react-hooks';
import _ from 'lodash';

import useDispensary from 'src/dispensary/hooks/use-dispensary';

import useCart from 'hooks/use-cart';
import filteredSpecials from 'shared/graphql/special/queries/filtered-specials.gql';
import { parseDates, specialIsActive, specialMatchesMenuType } from 'shared/helpers/specials';
import { useObserver } from 'mobx-react';

export default function useDispensarySpecials() {
  const { dispensary } = useDispensary();
  const cart = useCart();
  const menuType = useObserver(() => cart.menuType);
  const enableLLxSaleDiscountSync = dispensary?.storeSettings?.enableLLxSaleDiscountSync;

  const variables = {
    specialsFilter: {
      dispensaryId: dispensary?.id,
      current: true,
    },
  };
  // eslint-disable-next-line no-use-before-define
  const { data, ...apolloValues } = useQuery(filteredSpecials, {
    skip: !dispensary,
    variables,
  });

  const parsedFilteredSpecials = _.map(data?.filteredSpecials?.specials || [], (s) => parseDates(s));
  const [currentSpecials] = _.reduce(
    parsedFilteredSpecials,
    (accumulator, special) => {
      if (special.source !== 'POS' || (special.specialType === 'sale' && enableLLxSaleDiscountSync)) {
        accumulator[specialIsActive(special) && specialMatchesMenuType(special, menuType) ? 0 : 1].push(special);
      }
      return accumulator;
    },
    [[], []]
  );

  const specials = [..._.sortBy(currentSpecials, ({ startStamp }) => startStamp)];
  const hasSpecials = specials?.length > 0;

  return { specials, hasSpecials, ...apolloValues };
}
